// extracted by mini-css-extract-plugin
export default {"GraphicPromotion":"GraphicPromotion_GraphicPromotion__MTAxZ","GraphicPromotion__disclaimer":"GraphicPromotion_GraphicPromotion__disclaimer__M2ZmY"};